import { atom } from 'recoil';
import defaultProjectMediaFilesSearchTerm from 'ProjectManager/Project/ProjectMediaFiles/recoil/projectMediaFilesSearchTerm/defaultProjectMediaFilesSearchTerm';

const projectMediaFilesSearchTermAtom = atom({
    key: 'projectManagement_projectMediaFilesSearchTerm',
    default: defaultProjectMediaFilesSearchTerm,
});

export default projectMediaFilesSearchTermAtom;
